(function () {
  const store = window.ScrubLabTeams.store;

  function escapeHTML(value) {
    return String(value ?? '').replace(/[&<>"']/g, (character) => {
      const characters = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };

      return characters[character];
    });
  }

  // FORMAT EMBROIDERY DETAILS FOR THE BUNDLE SIDEBAR
  // COMPACT EMBROIDERY SUMMARY
  function renderEmbroideryDetails(item) {
    if (!item.embroidery?.properties) return '';

    const properties = item.embroidery.properties;
    const details = [];

    const formatType = (type) => {
      const types = {
        text: 'Text',
        logo: 'Logo',
        both: 'Logo + Text'
      };

      return types[String(type || '').toLowerCase()] || type;
    };

    ['Left', 'Right'].forEach((side) => {
      const type = properties[`${side} Chest Type`];

      if (!type || String(type).toLowerCase() === 'none') {
        return;
      }

      details.push(
        `<strong>${side} chest: ${escapeHTML(formatType(type))}</strong>`
      );

      const name = properties[`${side} Text Line 1`];
      const role = properties[`${side} Text Line 2`];
      const logoSource = properties[`${side} Logo Source`];

      if (name) {
        details.push(`Name: ${escapeHTML(name)}`);
      }

      if (role) {
        details.push(`Role: ${escapeHTML(role)}`);
      }

      if (logoSource) {
        const logoName =
          properties[`${side} Returning Customer Logo`] ||
          properties[`${side} Hospital Logo`] ||
          '';

        details.push(
          `Logo: ${escapeHTML(logoSource)}` +
          (logoName ? ` (${escapeHTML(logoName)})` : '')
        );
      }
    });

    if (!details.length) return '';

    return `
      <div class="team-builder__embroidery-details"
           style="display:flex;flex-direction:column;gap:4px;margin:10px 0;font-size:13px;line-height:1.4;">
        <span style="font-weight:600;">Embroidery</span>
        ${details.map((detail) => `<span>${detail}</span>`).join('')}
      </div>
    `;
  }


  // RENDER BUNDLE ITEMS
  function renderBundle() {
    const container = store.els.members;

    if (!container) return;

    if (!store.state.items.length) {
      container.innerHTML = `
        <div class="team-builder__empty">
          <strong>Your bundle is empty.</strong>
          <span>Browse our products to start building your bundle.</span>
        </div>
      `;
      return;
    }

    container.innerHTML = store.state.items.map((item) => {
      const title = escapeHTML(item.title);
      const variant = escapeHTML(item.variantTitle);
      const image = escapeHTML(item.image || '');
      const quantity = item.quantity;

      const embroideryPrice = Number(item.embroidery?.price || 0);
      const garmentTotal = item.price * quantity;
      const embroideryTotal = embroideryPrice * quantity;
      const itemTotal = garmentTotal + embroideryTotal;

      return `
        <div class="team-builder__bundle-item">

          <div class="team-builder__bundle-item-image">
            ${image
              ? `<img src="${image}" alt="${title}" loading="lazy">`
              : ''
            }
          </div>

          <div class="team-builder__bundle-item-info">
            <strong>${title}</strong>
            <span>${variant}</span>

            ${renderEmbroideryDetails(item)}

            <div class="team-builder__bundle-item-price">

              <div>
                Garment: ${store.money(garmentTotal)}
              </div>

              ${embroideryTotal > 0 ? `
                <div>
                  Embroidery: +${store.money(embroideryTotal)}
                </div>
              ` : ''}

              <strong>
                ${store.money(itemTotal)}
              </strong>

            </div>

            <div class="team-builder__bundle-item-actions">

              <div class="team-builder__quantity">
                <button
                  type="button"
                  data-decrease-quantity="${item.id}"
                  aria-label="Decrease quantity"
                >−</button>

                <span>${quantity}</span>

                <button
                  type="button"
                  data-increase-quantity="${item.id}"
                  aria-label="Increase quantity"
                >+</button>
              </div>

              <button
                type="button"
                class="team-builder__remove"
                data-remove-item="${item.id}"
                aria-label="Remove item"
              >
                ×
              </button>

            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  // RENDER DISCOUNT PROGRESS
  function renderProgress() {
    const count = store.getTotalItems();
    const target = store.state.itemTarget;

    const percent = Math.min((count / target) * 100, 100);
    const remaining = Math.max(target - count, 0);

    store.els.itemCount.textContent = `${count} / ${target} items`;
    store.els.progressBar.style.width = `${percent}%`;

    store.els.discountMessage.textContent =
      store.isDiscountUnlocked()
        ? '10% bundle discount unlocked!'
        : `${remaining} more ${remaining === 1 ? 'item' : 'items'} to unlock 10% off`;
  }

  // RENDER PRICE SUMMARY
  function renderTotals() {
    let totals = store.root.querySelector('[data-bundle-totals]');

    if (!totals) {
      totals = document.createElement('div');
      totals.className = 'team-builder__totals';
      totals.dataset.bundleTotals = '';

      store.els.progressBar
        .closest('.team-builder__progress')
        .insertAdjacentElement('afterend', totals);
    }

    const subtotal = store.getSubtotal();
    const embroiderySubtotal = store.getEmbroiderySubtotal();
    const discount = store.getDiscountAmount();
    const total = store.getTotal();

    totals.innerHTML = `
      <div class="team-builder__totals-row">
        <span>Subtotal</span>
        <strong>${store.money(subtotal)}</strong>
      </div>

      <div class="team-builder__totals-row">
        <span>Bundle discount</span>
        <strong>${discount > 0 ? '−' : ''}${store.money(discount)}</strong>
      </div>

      ${embroiderySubtotal > 0 ? `
        <div class="team-builder__totals-row">
          <span>Embroidery</span>
          <strong>+${store.money(embroiderySubtotal)}</strong>
        </div>
      ` : ''}

      <div class="team-builder__totals-row team-builder__totals-row--total">
        <span>Estimated total</span>
        <strong>${store.money(total)}</strong>
      </div>
    `;
  }

  // UPDATE CHECKOUT BUTTON
  function renderCheckoutButton() {
    const button = store.root.querySelector(
      '[data-add-bundle-to-cart]'
    );

    const message = store.root.querySelector(
      '[data-checkout-message]'
    );

    if (!button || !message) return;

    const itemCount = store.getTotalItems();
    const hasItems = itemCount > 0;

    button.disabled = !hasItems;

    button.textContent = 'Add Bundle to Cart';

    if (!hasItems) {
      message.textContent = 'Add a product to get started.';
    } else if (store.isDiscountUnlocked()) {
      message.textContent = 'Your 10% bundle discount is unlocked!';
    } else {
      message.textContent =
        'You can purchase now or add more items to unlock 10% off.';
    }
  }

  // UPDATE MOBILE BUNDLE BAR
  function renderMobileBundleBar() {
    const countElement = store.root.querySelector(
      '[data-mobile-bundle-count]'
    );

    const totalElement = store.root.querySelector(
      '[data-mobile-bundle-total]'
    );

    if (!countElement || !totalElement) return;

    const count = store.getTotalItems();
    const total = store.getTotal();

    countElement.textContent =
      `${count} ${count === 1 ? 'ITEM' : 'ITEMS'}`;

    totalElement.textContent = store.money(total);
  }

  // UPDATE INTERFACE
  store.render = function () {
    renderBundle();
    renderProgress();
    renderTotals();
    renderCheckoutButton();
    renderMobileBundleBar();
  };
})();